import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {IntegrationsContainerDefault} from './DefaultVariation'
import {IntegrationsContainerV2} from './VariationV2'

/**
 * Props for `IntegrationsContainer`.
 */
export type IntegrationsContainerProps = SliceComponentProps<Content.IntegrationsContainerSlice> & {
  context: {pageUid: string}
}

/**
 * Component for "IntegrationsContainer" Slices.
 */
const IntegrationsContainer = ({slice, context, index: componentIndex}: IntegrationsContainerProps): JSX.Element => {
  switch (slice.variation) {
    case 'default':
      return <IntegrationsContainerDefault slice={slice} context={context} index={componentIndex} />
    case 'v2':
      return <IntegrationsContainerV2 slice={slice} context={context} index={componentIndex} />
    default:
      return <></>
  }
}

export default IntegrationsContainer
